<template>
  <div id="login-page">
    <center>
      <h1>Contact Us</h1>
      <p>Enter your message below</p>
    </center>
    <hr>
    <v-app id="inspire">
      <center>
        <div class="contactHelper">
          <h2>Enter Your Message Below</h2>
          <br>
          <p>You may also email us at <a :href="`mailto:${supportEmail}`">{{supportEmail}}</a></p>
        </div>
      </center>
      <v-container fluid id=contact-form>
        <v-form ref="contact" v-model="valid" lazy-validation>
          <v-text-field v-model="subject" :rules="subjectRules" label="Subject" required> </v-text-field>
          <v-textarea auto-grow v-model="message" :rules="messageRules" label="Message" required> </v-textarea>
          <v-btn :disabled="!valid" color="success" @click="contact(subject,message)">Send!</v-btn>
        </v-form>
        </v-container>
        <center>
          <p>We will respond to the email address you have on your account</p>
        </center>
      
    </v-app>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>


<script>
export default {
  data: () => ({
    name: 'Login',
    valid: true,
    subject: '',
    message: '',
    loading: false,
    supportEmail: "support@firewatch101.com",
    snackbar: {
      show: false,
      message: null,
      color: "primary"

    },
    subjectRules: [
        v => !!v || 'Subject is required',
      ],
    messageRules: [
        v => !!v || 'Message is required',
      ],

    }),
  created(){
      if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async contact(subject, message){    
      if (!this.$refs.contact.validate()){
        this.error("There is an error in the contact form");
        return
      }
      this.loading = true;

        const contactResponse = await fetch(localStorage.apiURL + "/app/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json", "deviceID": localStorage.token, "tokenID": localStorage.tokenID },
        body: JSON.stringify({ 
              subject: subject,
              message: message
        })
      })
      const contactData = await contactResponse.json();

      if (!contactData.success){
        this.error("An error occured: " + contactData.msg)
        this.loading = false;
        return
      }

      this.loading = false;
      
      alert("Your message has been sent")
      this.$router.push({path: 'watchlist'});
    },
  }
}
</script>

<style scoped>
@media screen and (max-width: 1500px) {
  #contact-form {
    margin-top: 25px;
    margin-left: 20px;
    margin-right: 20px;
    align-content: center;
  }
}
@media screen and (min-width: 1500px) {
#contact-form {
  margin-top: 100px;
  margin-left: 25%;
  align-content: center;
  width: 50%
}
}
#contact-header {
  text-align: center;
}
.contactHelper{
  margin-top: 50px;
}
</style>